import React from 'react';
import { FormControlLabel, Switch as MuiSwitch, FormHelperText, FormControl } from '@mui/material';
import type { Switch as Interface } from '../../design/components';

export const Switch: React.FC<Interface> = ({
  name, description, state, hidden, inline, disabled, required, error
}) => {
  const [value, setValue] = state || [false, () => {}];

  // Inline mode: render just the switch
  if (inline) {
    return (
      <MuiSwitch
        id={name}
        name={name}
        checked={!!value}
        disabled={disabled}
        required={required}
        onChange={(e) => setValue(e.target.checked)}
        sx={{ display: hidden ? 'none' : undefined }}
      />
    );
  }

  return (
    <FormControl error={!!error} sx={{ display: hidden ? 'none' : undefined, mb: 1 }}>
      <FormControlLabel
        control={
          <MuiSwitch
            id={name}
            name={name}
            checked={!!value}
            disabled={disabled}
            required={required}
            onChange={(e) => setValue(e.target.checked)}
          />
        }
        label={name}
      />
      {(error || description) && (
        <FormHelperText>{error || description}</FormHelperText>
      )}
    </FormControl>
  );
};
